import { useEffect, useState, useRef } from 'react'
import { useTranslation } from "react-i18next";
import helpers from "../../../helpers";

import useMutation from 'hooks/useMutation'
let clone = window.structuredClone || JSON.clone

let {
  REACT_APP_INCREASE_CHECKOUT_LITE_URL,
  REACT_APP_INCREASE_ACCOUNT_ID
} = process.env

export function IncreaseCheckoutLite({ subscriptionID, className, onUpdate }) {
  const { t } = useTranslation();
  let $iframe = useRef(null)
  let [status, setStatus] = useState({ })
  // Bug real (auditoría 2026-08-16): status.load es truthy también en el
  // caso 'error', y el iframe se ocultaba (display:none) salvo cuando
  // status.load === 'ready' — el spinner desaparecía (!status.load pasa a
  // false) pero el iframe seguía oculto, dejando al usuario frente a una
  // pantalla en blanco sin ningún error ni forma de reintentar. `retryKey`
  // fuerza un remount del <iframe> (cambia src efectivamente) al reintentar.
  let [retryKey, setRetryKey] = useState(0)

  // Bug de seguridad: sin validar origin/source, CUALQUIER ventana/origen
  // podía postear {type:'PAYMENT_SUCCESS'} y este componente lo tomaba como
  // confirmación real de pago del proveedor. Se valida que el mensaje venga
  // del origin del iframe de checkout (derivado de la misma URL que se le
  // pasa como src) Y de esa instancia de iframe puntual.
  let checkoutOrigin
  try {
    checkoutOrigin = new URL(REACT_APP_INCREASE_CHECKOUT_LITE_URL).origin
  } catch { }

  useEffect(() => {
    let callback = message => {
      if (checkoutOrigin && message.origin !== checkoutOrigin) return
      if ($iframe.current && message.source !== $iframe.current.contentWindow) return
      let { payload, type } = message?.data || {}
      if (onUpdate) onUpdate(type)
      if (type === 'PAYMENT_SUCCESS') {
        setStatus(status => ({ ...status, payment: 'success' }))
      } else if (type === 'PAYMENT_ERROR') {
        setStatus(status => ({ ...status, payment: 'error' }))
      } else if (type === 'PAYMENT_IN_PROCESS') {
        setStatus(status => ({ ...status, payment: 'process' }))
      } else if (type === 'LOAD_ERROR') {
        setStatus(status => ({ ...status, load: 'error' }))
      } else if (type === 'LOAD_SUCCESS') {
        setStatus(status => ({ ...status, load: 'ready' }))
      }
    }

    window.addEventListener('message', callback);

    return () => window.removeEventListener('message', callback)
  }, [$iframe.current])

  if (!subscriptionID || !REACT_APP_INCREASE_CHECKOUT_LITE_URL) return null
  let options = {
    container: 'overflow-hidden',
    iframe: { width: '685px', height: '410px' }
  }
  if (window.document.body.clientWidth <= 650) {
    options.container = ''
    options.iframe = { width: '100%', height: '100vh' }
  }
  return (
    <div className={[options.container, 'position-relative', className || 'bg-white'].filter(Boolean).join(' ')}>
      <div
        style={status.load === 'ready' ? ({ height: '382px', marginTop: '-104px' }) : ({})}
      >
        {!status.load && (
          <div className="d-flex justify-content-center align-items-center">
            <span className="spinner-border text-primary" role="status"></span>
          </div>
        )}

        {status.load === 'error' && (
          <div className="d-flex flex-column justify-content-center align-items-center gap-2 p-4 text-center">
            <div>{t('checkout_lite_load_error', 'No se pudo cargar el formulario de pago. Intentá de nuevo.')}</div>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={() => {
                setStatus(status => ({ ...status, load: undefined }))
                setRetryKey(key => key + 1)
              }}
            >
              {t('retry', 'Reintentar')}
            </button>
          </div>
        )}

        <iframe
          key={retryKey}
          ref={$iframe}
          id="checkoutLiteIframe"
          style={status.load !== 'ready' ? ({ display: 'none' }) : options.iframe}
          src={`${REACT_APP_INCREASE_CHECKOUT_LITE_URL}?subscription_id=${subscriptionID}`}
        />
      </div>
      {/* Bug real (auditoría 2026-08-18, responsive): este panel de tarjetas
          de prueba (solo sandbox) se posicionaba con left:690px fijo,
          pensado para quedar a la derecha del iframe de 685px en desktop.
          En mobile, el iframe pasa a width:100% (más arriba) pero este panel
          seguía en left:690px -- con el viewport a 375px queda 100% fuera
          de pantalla, y el overflow-x:hidden global impide recuperarlo ni
          con scroll. En mobile se muestra debajo del iframe (flujo normal)
          en vez de posicionado absoluto a la derecha. */}
      {status.load === 'ready' && REACT_APP_INCREASE_CHECKOUT_LITE_URL.includes('pay-sandbox') && (
        <div
          className={options.container === '' ? 'mt-3' : 'position-absolute top-0'}
          style={options.container === '' ? { zIndex: 10 } : { left: '690px', zIndex: 10 }}
        >
          <div className="bg-light p-3 border rounded">
            <pre style={{ whiteSpace: 'pre-line' }} className="m-0">{`5399090000000009
            4850110000000000

            APPROVED 05/25 777
            REJECTED 07/27 666`}</pre>
          </div>
          <a className="lh-1 mt-3" href="https://developers.increase.app/docs/how_to_test_payments#tarjetas-de-prueba" rel="noopener noreferrer" target="_blank">
            <small>Pagos de prueba</small>
          </a>
        </div>
      )}
    </div>
  )
}
